<ng-template let-extraClass="extraClass" #topNav>
  @if (!windowService?.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Connect Locks'"
      [canGoBack]="true"
      [customBackAction]="mobileBackAction" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>
    @if (showWizardChrome) {
      <div class="wizard-progress-bar">
        <div class="wizard-progress-fill" [style.width.%]="progressPercent"></div>
      </div>

      <div class="wizard-step-header">
        <tidy-text [title]="stepHeaderTitle" />
      </div>
    }

    @if (currentStep === 1) {
      @if (step1State === 'loading') {
        <div class="loading-container">
          <tidy-loader />
        </div>
      }

      @if (step1State === 'intro') {
        <div class="wizard-content">
          <tidy-row [align]="'center'">
            <tidy-text [body]="'Connect a Seam account to import your smart locks. You can connect more than one provider.'" />
          </tidy-row>
          <div class="wizard-nav-row">
            <tidy-button
              [text]="'Connect Seam'"
              [action]="connectLocks"
              class="primary" />
          </div>
        </div>
      }

      @if (step1State === 'connecting') {
        @if (!seamWebviewUrl) {
          <div class="loading-container">
            <tidy-loader />
          </div>
        }

        @if (seamWebviewUrl) {
          <div class="seam-webview-container">
            <iframe
              [src]="seamWebviewUrl"
              class="seam-webview-iframe"
              frameborder="0"
              title="Connect Smart Locks">
            </iframe>
          </div>
        }
      }

      @if (step1State === 'saving') {
        <div class="loading-container">
          <tidy-loader />
          <tidy-row [align]="'center'">
            <tidy-text [body]="'Saving your smart lock connection...'" />
          </tidy-row>
        </div>
      }

      @if (step1State === 'connected') {
        <div class="wizard-content">
          <tidy-card>
            <tidy-row class="vertical-align-center">
              <tidy-image
                [src]="'assets/svg/checkmark-circle-outline.svg'"
                class="body-size" />
              <tidy-text [header]="'Smart Locks Connected'" />
            </tidy-row>
            <tidy-row class="vertical-align-center">
              @if (providerImageUrl) {
                <tidy-image
                  [src]="providerImageUrl"
                  class="header-size" />
              }
              <tidy-text
                [body]="providerName ? ('Provider: ' + providerName) : 'Your smart locks are connected via Seam.'" /><span>&nbsp;</span>
              <tidy-text
                [actionBody]="isDisabling ? 'Disabling...' : 'Disable'"
                (action)="confirmAndDisable()"
                class="red link" />
            </tidy-row>
          </tidy-card>

          <div class="wizard-nav-row">
            <tidy-button
              [text]="'Add Another Connection'"
              [action]="connectLocks"
              [class]="addSeamMode ? 'primary' : 'secondary'" />
            @if (!addSeamMode) {
              <tidy-button
                [text]="'Next'"
                [action]="goToStep2FromNext"
                class="primary" />
            }
          </div>
        </div>
      }

      @if (step1State === 'error') {
        <div class="wizard-content">
          <tidy-error-message [text]="errorMessage" />
          <div class="wizard-nav-row">
            <tidy-button
              [text]="'Try Again'"
              [action]="retryStep1"
              class="primary" />
          </div>
        </div>
      }
    }

    @if (currentStep === 2) {
      @if (step2State === 'loading') {
        <div class="loading-container">
          <tidy-loader />
        </div>
      }

      @if (step2State === 'error') {
        <div class="wizard-content">
          <tidy-error-message [text]="step2ErrorMessage" />
          <div class="wizard-nav-row">
            <tidy-button
              [text]="'Try Again'"
              [action]="retryStep2"
              class="primary" />
          </div>
        </div>
      }

      @if (step2State === 'empty') {
        <div class="wizard-content">
          <tidy-alert>
            <tidy-row>
              <tidy-text [body]="'No smart locks were found on your connection. Try adding a different account.'" />
            </tidy-row>
          </tidy-alert>
        </div>
      }

      @if (step2State === 'ready') {
        <div class="wizard-content">
          <tidy-row [align]="'center'">
            <tidy-text
              [body]="'Locks can be associated with multiple properties.'" />
          </tidy-row>

          <form [formGroup]="addressForm" novalidate action="#">
            <tidy-select
              [label]="'Property'"
              [icon]="'assets/svg/home-outline.svg'"
              [form]="addressForm.controls.addressId"
              formControlName="addressId"
              [items]="addressItems"
              [disabled]="addressLocked"
              (optionChange)="onAddressSelectChange()" />
          </form>

          <div class="wizard-cards">
            @for (row of deviceRows; track trackRow($index, row)) {
              <tidy-card class="wizard-card lock-card">
                <tidy-checkbox
                  [items]="[row.checkboxItem]"
                  [initValue]="row.checked"
                  (checkedChange)="toggleDevice(row)" />
                @if (row.caption) {
                  <div class="lock-card-caption">
                    <tidy-text
                      [helper]="row.caption"
                      [translate]="false" />
                  </div>
                }
              </tidy-card>
            }
          </div>

          <div class="wizard-nav-row">
            <tidy-button
              [text]="saveButtonLabel"
              [action]="save"
              class="primary"
              [disabled]="saving" />
          </div>
        </div>
      }
    }
  </tidy-wrapper>
</ng-template>

@if (!windowService?.isDesktopRes) {
  <app-scroll-wrapper [templateContent]="content" />
} @else {
  <ng-container *ngTemplateOutlet="content" />
}
